import React, { Fragment } from "react";
import { lazyWithRetry } from "../../core/lazy_with_retry";

import { OfferingDetailsDayPass } from "../template_offering_details_daypass";
import { useMercuryCenterAnalytics } from "./mercury-center_analytics";
import {
  generalInfo,
  partnerConfig,
  testimonials,
} from "./mercury-center_partner_config";

const Theme = lazyWithRetry(() => import("./mercury-center_theme"));

const faqs = [
  {
    question: "What are your hours?",
    answer: "We are open Monday to Friday from 9:30am to 7:30pm.",
  },
  {
    question: "Is there somewhere I can park my car?",
    answer:
      "For your convenience there are paid parking lots located near our space.",
  },
  {
    question: "What's included with my day pass?",
    answer:
      "Work among like-minded professionals and enjoy high speed internet, printing services, and beverages.",
  },
  {
    question: "Is there somewhere I can make a call or have a meeting?",
    answer:
      "We offer private offices and meeting rooms for additional purchase to make calls and host meetings.",
  },
  {
    question: "Can I bring my own snacks?",
    answer: "You are welcome to bring your own snacks.",
  },
];

export function OfferingMercuryCenterDayPass() {
  useMercuryCenterAnalytics();

  return (
    <Fragment>
      <Theme />
      <OfferingDetailsDayPass
        showAddress={false}
        showDirections
        partnerConfig={partnerConfig}
        data={{
          description: `
          Our flexible floor plans and space solutions offer our members
          the option to be working with like-minded professionals in
          an open-plan coworking workstation.
          `,
          testimonials: testimonials,
          faqs: faqs,
          generalInfo,
        }}
      />
    </Fragment>
  );
}
